import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { SafeResourcePipe } from '../../pipes/safe-resource.pipe';
import { MatButtonModule } from '@angular/material/button';
import { ToHttpsPipe } from '../../pipes/to-https.pipe';

@Component({
    selector: 'app-iframe-dialog',
    standalone: true,
    imports: [CommonModule, SafeResourcePipe, MatButtonModule, MatDialogActions, MatDialogClose, ToHttpsPipe],
    templateUrl: './iframe-dialog.component.html',
    styleUrl: './iframe-dialog.component.scss',
})
export class IframeDialogComponent {

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            uri: string,
        },
    ) {
        //
    }
}
